export const modalStyles = (small: boolean, full: boolean) => {
  if (small) {
    return {
      overlay: { zIndex: 1000, backgroundColor: "#00000000" },
      content: {
        borderRadius: 0,
        border: 'none',
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center"
      },
    }
  } else if(full) {
    return {
      overlay: {
        zIndex: 99999,
        backgroundColor: "#000000cc",
      },
      content: {
        borderRadius: "0px",
        top: "auto",
        bottom: "auto",
        left: "auto",
        right: "auto",
      },
    }
  }
  else {
    return {
      overlay: {
        zIndex: 1000,
        backgroundColor: "#000000cc",
      },
      content: {
        borderRadius: "16px",
        top: "auto",
        bottom: "auto",
        left: "auto",
        right: "auto",
      },
    }
  }
}